import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import echarts from 'echarts';

export default class ChartHelper {
    constructor() {
        this.colorWheel = ['#76FF03', '#C6FF00', '#FFEA00', '#FFC400', '#FF9100', '#FF3D00',
            '#FF1744', '#F50057', '#D500F9', '#651FFF', '#3D5AFE', '#2979FF', '#00B0FF', '#00E5FF',
            '#1DE9B6', '#00E676', '#64DD17', '#AEEA00', '#FFD600', '#FFAB00', '#FF6D00', '#DD2C00', '#D50000',
            '#C51162', '#AA00FF', '#6200EA', '#304FFE', '#2962FF', '#0091EA', '#00B8D4', '#00BFA5', '#00C853',
            '#B2FF59', '#EEFF41', '#FFFF00', '#FFD740', '#FFAB40', '#FF6E40', '#FF5252', '#FF4081', '#E040FB',
            '#7C4DFF', '#536DFE', '#448AFF', '#40C4FF', '#18FFFF', '#64FFDA', '#69F0AE'];

        this.generateBarChart = this.generateBarChart.bind(this);
        this.generateDoubleBarChart = this.generateDoubleBarChart.bind(this);
        this.generatePosNegBarChart = this.generatePosNegBarChart.bind(this);
        this.generateOverlapBarChart = this.generateOverlapBarChart.bind(this);
        this.generateStackupBarChart = this.generateStackupBarChart.bind(this);
        this.generateStackupBellChart = this.generateStackupBellChart.bind(this);
        this.generatePieChart = this.generatePieChart.bind(this);
        this.generateDoublePieChart = this.generateDoublePieChart.bind(this);
        this.generateLineFillChart = this.generateLineFillChart.bind(this);
        this.generateContestRaffleChart = this.generateContestRaffleChart.bind(this);
        this.generateDateLineChart = this.generateDateLineChart.bind(this);
    }

    generateBarChart(xData, yData) {
        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },
                series: [{
                    color: ['#00cfbb'],
                    data: yData,
                    type: 'bar'
                }]
            }}
        />);
    }

    generateDoubleBarChart(xData, yData1, yData2) {

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },
                series: [{
                    color: ['#28BEFF'],
                    data: yData1,
                    type: 'bar'
                }, {
                    color: ['#007EB5'],
                    data: yData2,
                    type: 'bar'
                }]
            }}
        />);
    }

    generatePosNegBarChart(xData, yData) {

        let yData1 = [];
        let yData2 = [];
        for (var i = 0; i < yData.length; i++) {
            if (yData[i] >= 0) {
                yData1.push(yData[i]);
                yData2.push(0);
            } else {
                yData1.push(0);
                yData2.push(yData[i]);
            }
        }

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },
                series: [{
                    color: ['#49ca75'],
                    data: yData1,
                    type: 'bar'
                }, {
                    color: ['#fe0101'],
                    data: yData2,
                    type: 'bar',
                    barGap: '-100%'
                }]
            }
            }
        />);
    }

    generateRollupBarChart(yData1, yData2) {

        let borderBar = 0
        let totalFillG = [];
        let totalFillR = [];

        let tempTotal = 0;
        for (var i = 0; i < yData1.length; i++) {
            borderBar += yData2[i];
            tempTotal += yData1[i];
        }

        tempTotal = borderBar != 0 ? (tempTotal / borderBar) : 0;
        borderBar = 1;

        if (tempTotal >= borderBar) {
            // totalFillG.push(tempTotal);
            totalFillG.push(1);
            totalFillR.push(0);
            borderBar = tempTotal != 0 ? (borderBar / tempTotal) : 0;
        } else {
            totalFillG.push(0);
            totalFillR.push(tempTotal);
        }

        return (<ReactEcharts
            className="test-chart-short"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'category',
                    data: ['Total'],
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
                series: [{
                    color: ['rgba(0, 0, 0, 0)'],
                    itemStyle: { normal: { barBorderColor: '#26262a', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: [borderBar],
                    type: 'bar',
                    z: 3
                }, {
                    color: ['#fbfbfb'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: [borderBar],
                    type: 'bar',
                    z: 0
                }, {
                    color: ['#49ca75'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: totalFillG,
                    type: 'bar',
                    barGap: '-100%',
                    z: 1
                }, {
                    color: ['#fe0101'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: totalFillR,
                    type: 'bar',
                    barGap: '-100%',
                    z: 2
                }]
            }}
        />);
    }

    generateProgressBarChart(xData, yData1, yData2) {


        let borderBar = [];
        let fillG = [];
        let fillR = [];
        for (var i = 0; i < xData.length; i++) {
            if (yData1[i] >= yData2[i]) {
                fillG.push(yData1[i]);
                fillR.push(0);
            } else {
                fillG.push(0);
                fillR.push(yData1[i]);
            }
            borderBar.push(yData2[i]);
        }

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },

                series: [{
                    color: ['rgba(0, 0, 0, 0)'],
                    itemStyle: { normal: { barBorderColor: '#26262a', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: borderBar,
                    type: 'bar',
                    z: 4
                }, {
                    color: ['#fbfbfb'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: borderBar,
                    type: 'bar',
                    z: 1
                }, {
                    color: ['#49ca75'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: fillG,
                    type: 'bar',
                    barGap: '-100%',
                    z: 2
                }, {
                    color: ['#fe0101'],
                    itemStyle: { normal: { barBorderColor: '#ffffff', barBorderWidth: 1, barBorderRadius: 0 } },
                    data: fillR,
                    type: 'bar',
                    barGap: '-100%',
                    z: 3
                }]
            }}
        />);
    }

    generateOverlapBarChart(xData, yData1, yData2, floating) {

        let mask = [];
        let maskFloatG = [];
        let maskFloatR = [];
        for (var i = 0; i < yData1.length; i++) {
            if (yData1[i] > yData2[i]) {
                mask.push(yData2[i]);
                maskFloatG.push(yData1[i] - yData2[i]);
                maskFloatR.push(0);
            } else {
                mask.push(yData1[i]);
                maskFloatG.push(0);
                maskFloatR.push(yData2[i] - yData1[i]);
            }
        }
        // let maskColor = '#00cfbb';
        let maskColor = '#d5d5d5';
        let maskBorderColor = '#000000';
        if (floating) {
            maskColor = 'rgba(0, 0, 0, 0)';
            maskBorderColor = 'rgba(0, 0, 0, 0)';
        }

        //         series: [{
        //             color: ['#49ca75'],
        //             data: yData1,
        //             type: 'bar',
        //             z: 2
        //         }, {
        //             color: ['#fe0101'],
        //             data: yData2,
        //             type: 'bar',
        //             barGap: '-100%',
        //             z: 1
        //         }, {
        //             color: [maskColor],
        //             data: mask,
        //             type: 'bar',
        //             barGap: '-100%',
        //             z: 3
        //         }]

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },

                series: [{
                    color: [maskColor],
                    itemStyle: { barBorderColor: [maskBorderColor] },
                    data: mask,
                    stack: 'main',
                    type: 'bar',
                    z: 3
                }, {
                    color: ['#49ca75'],
                    data: maskFloatG,
                    stack: 'main',
                    type: 'bar',
                    barGap: '-100%',
                    z: 1
                }, {
                    color: ['#fe0101'],
                    data: maskFloatR,
                    stack: 'main',
                    type: 'bar',
                    barGap: '-100%',
                    z: 2
                }]
            }}
        />);
    }

    generateStackupBarChart(xData, yData) {

        let redData = [];
        let orangeData = [];
        let yellowData = [];
        let greenData = [];

        for (var i = 0; i < yData.length; i++) {
            if (yData[i] >= 75) {
                redData.push(0);
                orangeData.push(0);
                yellowData.push(0);
                greenData.push(yData[i]);
            } else if (yData[i] >= 50) {
                redData.push(0);
                orangeData.push(0);
                yellowData.push(yData[i]);
                greenData.push(0);
            } else if (yData[i] >= 25) {
                redData.push(0);
                orangeData.push(yData[i]);
                yellowData.push(0);
                greenData.push(0);
            } else {
                redData.push(yData[i]);
                orangeData.push(0);
                yellowData.push(0);
                greenData.push(0);
            }
        }


        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    },
                    splitLine: {
                        show: false
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },
                series: [{
                    itemStyle: {
                        normal: {
                            color: 'rgb(242, 88, 88)'
                        }
                    },
                    data: redData,
                    type: 'bar',
                    zlevel: 1
                },
                {
                    itemStyle: {
                        normal: {
                            color: 'rgb(255, 157, 0)'
                        }
                    },
                    data: orangeData,
                    type: 'bar',
                    barGap: '-100%',
                    zlevel: 1
                },
                {
                    itemStyle: {
                        normal: {
                            color: 'rgb(234, 240, 87)'
                        }
                    },
                    data: yellowData,
                    type: 'bar',
                    barGap: '-100%',
                    zlevel: 1
                },
                {
                    itemStyle: {
                        normal: {
                            color: 'rgb(73, 202, 117)'
                        }
                    },
                    data: greenData,
                    type: 'bar',
                    barGap: '-100%',
                    zlevel: 1
                },
                {
                    itemStyle: {
                        normal: {
                            opacity: 0
                        }
                    },
                    data: [100],
                    type: 'bar',
                    barGap: '-100%',
                    markLine: {
                        silent: true,
                        data: [{ yAxis: 100 }, { yAxis: 75 }, { yAxis: 50 }, { yAxis: 25 }],
                        lineStyle: {
                            normal: {
                                type: 'solid',
                                width: '1',
                                color: '#666'
                            }
                        },
                        symbol: 'none',
                        label: {
                            normal: {
                                show: false
                            }
                        }
                    },
                    zlevel: 0
                }]
            }}
        />);
    }

    generateStackupBellChart(xData, yData) {

        let linePointsX = [];
        let linePointsY = [];
        for (var i = 0; i <= 1; i += 0.01) {
            linePointsX.push(i);
            if (i >= 0 && i <= 1) {
                linePointsY.push((Math.sin(2.0 * Math.PI * (i - 0.25)) + 1.0) / 3.0);
            } else {
                linePointsY.push(0);
            }
        }

        let finalThing = [];
        for (var i = 0; i < linePointsX.length; i++) {
            finalThing.push([linePointsX[i], linePointsY[i]]);
        }

        let axisData = [];
        for (var i = 0; i < yData.length; i++) {
            axisData.push({ xAxis: yData[i] / 100.0 });
        }


        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    },
                    splitLine: {
                        show: false
                    }
                },
                visualMap: {
                    show: false,
                    dimension: '0',
                    top: 10,
                    right: 10,
                    orient: 'horizontal',
                    pieces: [{
                        gte: 0,
                        lt: 0.25,
                        color: 'rgb(242, 88, 88)'
                    }, {
                        gte: 0.25,
                        lt: 0.5,
                        color: 'rgb(255, 157, 0)'
                    }, {
                        gte: 0.5,
                        lt: 0.75,
                        color: 'rgb(234, 240, 87)'
                    }, {
                        gte: 0.75,
                        lt: 1,
                        color: 'rgb(73, 202, 173)'
                    }],
                    outOfRange: {
                        color: '#999'
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },
                series: [
                    {
                        type: 'line',
                        data: finalThing,
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                color: 'rgb(255, 70, 131)'
                            }
                        },
                        areaStyle: {
                            normal: {

                            }
                        },
                        markLine: {
                            silent: true,
                            data: axisData,
                            lineStyle: {
                                normal: {
                                    type: 'solid',
                                    width: '1',
                                    color: '#666'
                                }
                            },
                            symbol: 'diamond',
                            label: {
                                normal: {
                                    show: false
                                }
                            }
                        },
                    }
                ]
            }}
        />);
    }

    generatePieChart(data) {
        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                series: [{
                    data: data,
                    avoidLabelOverlap: true,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    radius: ['0%', '100%'],
                    type: 'pie',
                    color: this.colorWheel
                }]
            }}
        />);
    }

    generateDoublePieChart(labels, data1, data2) {

        let innerData = [];
        let outerData = [];
        for (var i = 0; i < labels.length; i++) {
            innerData.push({
                value: data1[i],
                name: labels[i]
            });
            outerData.push({
                value: data2[i],
                name: labels[i]
            });
        }


        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                series: [{
                    data: outerData,
                    avoidLabelOverlap: true,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    radius: ['65%', '100%'],
                    type: 'pie',
                    color: this.colorWheel
                }, {
                    data: innerData,
                    radius: ['0%', '45%'],
                    avoidLabelOverlap: true,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    type: 'pie',
                    color: this.colorWheel
                }]
            }}
        />);
    }

    generateLineFillChart(lineData, catQuan, goalLine) {
        let xData = [];
        for (var i = 0; i < catQuan; i++) {
            xData.push(i);
        }

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    color: ['#28BEFF'],
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },

                series: [{
                    color: ['#007EB5'],
                    data: lineData,
                    type: 'line',
                    areaStyle: {
                        // normal: {
                        //     color: '#49ca75',
                        //     origin: 'auto',
                        //     opacity: 0.87
                        // }
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(40, 190, 255)'
                            }, {
                                offset: 1,
                                color: 'rgb(0, 126, 181)'
                            }])
                        }
                    },
                    markLine: {
                        silent: true,
                        data: [{ yAxis: goalLine }],
                        lineStyle: {
                            normal: {
                                type: 'solid',
                                width: '1',
                                color: '#666'
                            }
                        },
                        symbol: 'none',
                        label: {
                            normal: {
                                show: false
                            }
                        }
                    }
                },
                {
                    type: 'bar',
                    data: [goalLine],
                    color: 'rgba(0, 0, 0, 0)',
                    itemStyle: {
                        normal: {
                            color: 'rgba(0, 0, 0, 0)',
                            opacity: 0
                        }
                    }
                }]
            }}
        />);
    }

    generateContestRaffleChart(identity, userStanceObj, selectedDate) {

        let catQuan = userStanceObj.longData.one.length;

        let xData = [];
        for (var i = 0; i < catQuan; i++) {
            xData.push(i);
        }
        let actQuan = 0;
        if (userStanceObj.longData.dates != undefined && userStanceObj.longData.dates.length != undefined) {
            for (var i = 0; i < userStanceObj.longData.dates.length; i++) {
                if (selectedDate >= userStanceObj.longData.dates[i]) {
                    actQuan = i + 1;
                }
            }
        }

        let line1Data = userStanceObj.longData.one;
        let line2Data = userStanceObj.longData.two;
        let line3Data = userStanceObj.longData.three;

        let goalLine1 = identity.valueOne;
        let goalLine2 = identity.valueTwo;
        let goalLine3 = identity.valueThree;

        let tmp1 = [];
        let tmp2 = [];
        let tmp3 = [];
        // for (var i = 0; i < line1Data.length; i++) {
        //     tmp1.push(line1Data[i] / goalLine1);
        // }
        // for (var i = 0; i < line2Data.length; i++) {
        //     tmp2.push(line2Data[i] / goalLine2);
        // }
        // for (var i = 0; i < line3Data.length; i++) {
        //     tmp3.push(line3Data[i] / goalLine3);
        // }
        for (var i = 0; i < actQuan; i++) {
            tmp1.push(line1Data[i] / goalLine1);
        }
        for (var i = 0; i < actQuan; i++) {
            tmp2.push(line2Data[i] / goalLine2);
        }
        for (var i = 0; i < actQuan; i++) {
            tmp3.push(line3Data[i] / goalLine3);
        }
        line1Data = tmp1;
        line2Data = tmp2;
        line3Data = tmp3;

        let goalLineTop = goalLine1;
        if (goalLine2 > goalLineTop) {
            goalLineTop = goalLine2;
        }
        if (goalLine3 > goalLineTop) {
            goalLineTop = goalLine3;
        }

        let line1 = {
            color: ['#007EB5'],
            data: line1Data,
            type: 'line',
            areaStyle: {
                normal: {
                    show: false,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgb(40, 190, 255)'
                    }, {
                        offset: 1,
                        color: 'rgb(73, 202, 117)'
                    }]),
                    opacity: 0
                }
            },
            markLine: {
                silent: true,
                // data: [{ yAxis: goalLine1 }],
                data: [{ yAxis: 1 }],
                lineStyle: {
                    normal: {
                        type: 'solid',
                        width: '1',
                        color: '#666'
                    }
                },
                symbol: 'none',
                label: {
                    normal: {
                        show: false
                    }
                }
            }
        };


        let line2 = {
            color: ['rgb(255, 0, 255)'],
            data: line2Data,
            type: 'line',
            areaStyle: {
                normal: {
                    show: false,
                    // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //     offset: 0,
                    //     color: 'rgb(191, 0, 255)'
                    // }, {
                    //     offset: 1,
                    //     color: 'rgb(255, 0, 255)'
                    // }]),
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgb(187, 0, 207)'
                    }, {
                        offset: 1,
                        color: 'rgb(181, 0, 126)'
                    }]),
                    opacity: 0
                }
            },
            markLine: {
                silent: true,
                // data: [{ yAxis: goalLine2 }],
                data: [{ yAxis: 1 }],
                lineStyle: {
                    normal: {
                        type: 'solid',
                        width: '1',
                        color: '#666'
                    }
                },
                symbol: 'none',
                label: {
                    normal: {
                        show: false
                    }
                }
            }
        };

        let line3 = {
            color: ['rgb(255, 0, 0)'],
            data: line3Data,
            type: 'line',
            areaStyle: {
                normal: {
                    show: false,
                    // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //     offset: 0,
                    //     color: 'rgb(255, 239, 0)'
                    // }, {
                    //     offset: 1,
                    //     color: 'rgb(255, 0, 0)'
                    // }]),
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgb(207, 187, 0)'
                    }, {
                        offset: 1,
                        color: 'rgb(126, 181, 0)'
                    }]),
                    opacity: 0
                }
            },
            markLine: {
                silent: true,
                // data: [{ yAxis: goalLine3 }],
                data: [{ yAxis: 1 }],
                lineStyle: {
                    normal: {
                        type: 'solid',
                        width: '1',
                        color: '#666'
                    }
                },
                symbol: 'none',
                label: {
                    normal: {
                        show: false
                    }
                }
            }
        };

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                yAxis: {
                    color: ['#007EB5'],
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0.25,
                            width: 2
                        }
                    }
                },
                grid: {
                    top: 0,
                    right: 0,
                    bottom: 2,
                    left: 2
                },

                series: [line1, line2, line3,
                    {
                        type: 'bar',
                        // data: [goalLineTop],
                        data: [1],
                        color: 'rgba(0, 0, 0, 0)',
                        itemStyle: {
                            normal: {
                                color: 'rgba(0, 0, 0, 0)',
                                opacity: 0
                            }
                        }
                    }]
            }}
        />);
    }

    generateDateLineChart(dataChunks, prefix, suffix) {

        if (prefix === undefined || prefix === null) {
            prefix = "";
        }
        if (suffix === undefined || suffix === null) {
            suffix = "";
        }

        let colorList = ['#007EB5', '#737373'];
        let colorIndex = 0;

        let seriesList = [];
        let z = 10;
        for (var i = 0; i < dataChunks.length; i++) {
            let data = dataChunks[i];

            let color = colorList[colorIndex];
            if (++colorIndex >= colorList.length) {
                colorIndex = 0;
            }

            seriesList.push({
                color: [color],
                name: "Point" + i,
                type: "line",
                showSymbol: false,
                hoverAnimation: false,
                data: data,
                z: z--
            });
        }

        let commaFormat = (num) => {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        return (<ReactEcharts
            className="test-chart"
            height={'100%'}
            notMerge={true}
            option={{
                title: {
                    show: false,
                    text: ""
                },
                tooltip: {
                    trigger: 'axis',
                    position: [0, 0],
                    backgroundColor: "#ffffff",
                    formatter: function (params) {

                        let neg = "";
                        let cyColor = "#888888";
                        if (params[1] != undefined) {
                            if (parseFloat(params[0].value[1]) >= parseFloat(params[1].value[1])) {
                                cyColor = "#007EB5";
                            } else {
                                cyColor = "#fe0101";
                                neg = "-"
                            }
                        }

                        var date = new Date(params[0].value[0]);
                        let displayString = '<span style="color: #00cfbb; display: block; position: absolute; right: 5px; top: 5px; font-weight: bold;">';
                        displayString += (date.getMonth() + 1) + "/" + date.getDate() + ' <span class="material-icons" style="font-size: 14px; vertical-align: text-top; width: 12px;">date_range</span></span> ';
                        displayString += '<span style="color: ' + cyColor + '; font-weight: bold;">' + prefix + commaFormat(params[0].value[1].toFixed(2)) + suffix + ' CY</span>';
                        if (params[1] != undefined) {
                            displayString += '<br /><span style="color: #888888; font-weight: bold;">' + prefix + commaFormat(params[1].value[1].toFixed(2)) + suffix + ' LY</span>';
                            displayString += '<span style="color: ' + cyColor + '; display: block; position: absolute; right: 5px; bottom: 5px; font-weight: bold;">';
                            displayString += neg + prefix + commaFormat((Math.abs(parseFloat(params[0].value[1]) - parseFloat(params[1].value[1]))).toFixed(2)) + suffix + ' Δ</span> ';
                        }
                        return displayString;
                    },
                    axisPointer: {
                        animation: false
                    }
                },
                grid: {
                    left: '40px',
                    bottom: '30px',
                    top: '70px'
                },
                xAxis: {
                    type: 'time',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function (label) {
                            let dt = new Date(label);
                            return (dt.getMonth() + 1) + "/" + dt.getDate();
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    boundaryGap: [0, '10%'],
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function (label) {
                            let rl = label;
                            let num = parseFloat(label);
                            if (num >= 1000000) {
                                rl = (num / 1000000.0).toFixed(1) + 'M';
                            } else if (num >= 1000) {
                                rl = (num / 1000.0).toFixed(0) + 'K';
                            } else {
                                rl = label;
                            }

                            return rl;
                        }
                    },
                },
                series: seriesList
            }}
        />);
    }
}

